import React from "react";
import { FIELD_TYPE, FORMAT_TIME, TT_PHIEU_KHO } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, CURRENCY } = FIELD_TYPE;
const fields: DataFormField[] = [
  {
    type: CURRENCY,
    name: "giamGia",
    label: "Số tiền miễn giảm",
    css: { xs: 12, sm: 12, md: 24, lg: 24, xl: 24 },
  },
  {
    type: INPUT,
    name: "lyDoGiam",
    label: "Lý do miễn giảm",
    css: { xs: 12, sm: 12, md: 24, lg: 24, xl: 24 },
  },
  {
    type: CURRENCY,
    name: "tongTien",
    hide: true,
  },
  {
    type: CURRENCY,
    name: "thanhTien",
    hide: true,
  },
];
export { fields };
